import { NgModule } from '@angular/core';
import { CrmExportDisabledTooltipPipe } from './crm-export-disabled-hover-message.pipe';

@NgModule({
    declarations: [CrmExportDisabledTooltipPipe],
    exports: [CrmExportDisabledTooltipPipe],
})
export class CrmExportDisabledTooltipPipeModule {}
